import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../Common";
import { load } from "..";
import { useLoggedInUser } from "../../Auth";

const useUsers = () => {
  const dispatch = useDispatch();
  const currentUsers = useSelector((state: IAppState) => state.userList);
  const user = useLoggedInUser();
  useEffect(() => {
    if (
      !!user &&
      !currentUsers.loadingState.isLoaded &&
      !currentUsers.loadingState.isLoading &&
      !currentUsers.loadingState.errored
    )
      dispatch(load());
  }, [currentUsers]);

  return currentUsers;
};

export default useUsers;
